export const TYPE_BICAGAME = "TYPE_BICAGAME";

